import { EventAction } from '~/app/tracking/feld-m-types';

// For tracking

export const checkEventActionUrl = (url: string) => {
	if (!url) return EventAction.InternalLink;
	const ngcBaseUrl = window.location.origin;
	try {
		const givenBaseUrl = new URL(url).origin;
		return ngcBaseUrl === givenBaseUrl ? EventAction.InternalLink : EventAction.ExitLink;
	} catch {
		return EventAction.InternalLink;
	}
};
